import { apiDelete, apiGet, apiPost, apiPut, hasOwn } from "../client";

function normalizeAdminTaskEditorPayload(taskData) {
  const src = taskData && typeof taskData === "object" ? taskData : {};
  const payload = {};

  if (hasOwn(src, "title")) {
    payload.title = String(src.title ?? "").trim();
  }

  if (hasOwn(src, "components_json")) {
    payload.components_json = Array.isArray(src.components_json)
      ? src.components_json
      : src.components_json ?? [];
  }

  const hasAssessmentFlag = hasOwn(src, "is_assessment");
  const normalizedIsAssessment = hasAssessmentFlag
    ? Number(src.is_assessment)
      ? 1
      : 0
    : null;

  if (hasAssessmentFlag) {
    payload.is_assessment = normalizedIsAssessment;
  }

  if (
    hasOwn(src, "assessment_title") ||
    (hasAssessmentFlag && normalizedIsAssessment === 0)
  ) {
    payload.assessment_title =
      normalizedIsAssessment === 1 ? String(src.assessment_title ?? "") : "";
  }

  if (
    hasOwn(src, "quiz_attempts_allowed") ||
    (hasAssessmentFlag && normalizedIsAssessment === 0)
  ) {
    payload.quiz_attempts_allowed =
      normalizedIsAssessment === 1
        ? Math.max(
            1,
            Math.min(
              50,
              Number.isFinite(Number(src.quiz_attempts_allowed))
                ? Number(src.quiz_attempts_allowed)
                : 1
            )
          )
        : 1;
  }

  if (
    hasOwn(src, "training_days_count") ||
    (hasAssessmentFlag && normalizedIsAssessment === 0)
  ) {
    payload.training_days_count =
      normalizedIsAssessment === 1
        ? Math.max(
            0,
            Math.min(
              30,
              Number.isFinite(Number(src.training_days_count))
                ? Number(src.training_days_count)
                : 0
            )
          )
        : 0;
  }

  return payload;
}

function normalizeAdminTaskUpdatePayload(taskData) {
  const src = taskData && typeof taskData === "object" ? taskData : {};
  const editorPayloadKeys = [
    "components_json",
    "is_assessment",
    "assessment_title",
    "quiz_attempts_allowed",
    "training_days_count",
  ];

  const isEditorPayload = editorPayloadKeys.some((key) => hasOwn(src, key));
  if (isEditorPayload) {
    return normalizeAdminTaskEditorPayload(src);
  }

  const payload = {};

  Object.entries(src).forEach(([key, value]) => {
    if (value !== undefined) {
      payload[key] = value;
    }
  });

  delete payload.assessment_difficulty;
  delete payload.linked_quiz_task_id;
  delete payload.linked_to_task_id;
  delete payload.tags;
  delete payload.tags_csv;

  return payload;
}

export async function fetchAdminTasks(dayId) {
  const query = dayId ? `?day_id=${encodeURIComponent(dayId)}` : "";
  return apiGet(`/tasks${query}`);
}

export async function fetchAdminTask(id) {
  return apiGet(`/tasks/${id}`);
}

export async function createAdminTask(taskData) {
  return apiPost("/tasks", taskData);
}

export async function updateAdminTask(id, taskData) {
  return apiPut(`/tasks/${id}`, normalizeAdminTaskUpdatePayload(taskData));
}

export async function deleteAdminTask(id) {
  return apiDelete(`/tasks/${id}`);
}
